import React, { useEffect, useState } from "react";
import { Position, ToolbarItem } from "devextreme-react/popup";
import { makeStyles } from "@mui/styles";
import { TextBox, TextArea } from "devextreme-react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ScrollView from "devextreme-react/scroll-view";
import Cookies from "universal-cookie";
import Lottie from "lottie-react-web";

import Host from "../../../../assets/js/Host";

import notify from "devextreme/ui/notify";
import { toast } from "react-toastify";
import PopupForm from "../../../../Components/PopupForm";
import CustomTextField from "../../../../Components/CustomTextField";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/system";
import { Button } from "@mui/material";
import axios from "../../../../assets/js/AxiosInterceptors";
import { useTheme } from '@mui/material/styles';

const cookies = new Cookies();

const useStyles = makeStyles(() => ({
  appBar: {
    position: "relative",
    backgroundColor: "#2e6b95",
  },
  title: {
    marginLeft: useTheme().spacing(2),
    flex: 1,
  },

  typographyClass: {
    fontFamily: "'Cairo'",
  },
  typographyOddClass: {
    fontFamily: "'Cairo'",
    color: "#2e6b95",
  },
  typographyEvenClass: {
    fontFamily: "'Cairo'",
    color: "#2e6b95",
  },
  containerHeader: {
    backgroundColor: "#f5f5f5",
  },
  innerContainerHeader: {
    paddingTop: useTheme().spacing(2),
    // paddingBottom: useTheme().spacing(1),

    justifyContent: "center",
    backgroundColor: "#f5f5f5",
  },
  firstColumnHeader: {
    borderRadius: "5px 5px 0px 0px",
    padding: "15px",
    textAlign: "center",
    backgroundColor: "#2e6b95",
    boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
    color: "#2e6b95",
  },
  secondColumnHeader: {
    borderRadius: "5px 5px 0px 0px",
    padding: "15px",
    textAlign: "center",
    backgroundColor: "#2e6b95",
    boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
    color: "#2e6b95",
  },
  thirdColumnHeader: {
    borderRadius: "5px 5px 0px 0px",
    textAlign: "center",
    padding: "15px",
    backgroundColor: "#e7e8e8",
    boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
    color: "#2e6b95",
  },
  fourthColumnHeader: {
    borderRadius: "5px 5px 0px 0px",
    backgroundColor: "#e7e8e8",
    textAlign: "center",
    boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
    padding: "15px",
    color: "#2e6b95",
  },

  ColumnHeaders: {
    textAlign: "center",
    fontWeight: 600,

    margin: "0 auto",
  },

  container: {
    height: "100%",
    backgroundColor: "#f5f5f5",
  },
  innerContainer: {
    // paddingTop: useTheme().spacing(1),
    paddingBottom: useTheme().spacing(1),
    height: "100%",
    justifyContent: "space-around",
    backgroundColor: "#f5f5f5",
  },
  firstColumn: {
    borderRadius: "0px 0px 0px 0px",
    padding: "15px",
    backgroundColor: "#ffffff",
    boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
  },
}));

const RenderContent = (props) => {
  const [t] = useTranslation("common");
  const maintheme = useSelector((state) => state.themeData.maintheme);
  return (
    <Box className="Container-fluid">
      <Box className="row pt-4">
        <Box className="col-12 col-sm-12 col-md-12 m-auto d-flex flex-column justify-content-center align-items-center">
          <CustomTextField
            label={"Customer Person"}
            haswidth={true}
            value={props?.data?.customerName}
            error={false}
            customWidth="100%"
            hasMultipleLine={false}
            onChange={(e) => {
              props?.CustomerNameChanged(e?.target);
            }}
            onClearClick={()=>{
                props?.CustomerNameChanged('');
            }}
            message={""}
            readOnly={false}
          />
          <Box sx={{ marginTop: "10px" }}></Box>
          <CustomTextField
            label={"Customer Phone Number"}
            haswidth={true}
            value={props?.data.customerPhone}
            error={props?.phoneEerror?.err}
            customWidth="100%"
            hasMultipleLine={false}
            onChange={(e) => {
              if (!isNaN(e?.target?.value)){
                props?.CustomerPhoneChanged(e?.target);
                props?.handlePhoneError(e?.target?.value)
              }
            }}
            onClearClick={()=>{
                props?.CustomerPhoneChanged('');
                props?.handlePhoneError('')
            }}
            errorMessage={props?.phoneEerror?.message}

            message={""}
            readOnly={false}
          />
          <Box sx={{ marginTop: "10px" }}></Box>
          <CustomTextField
            label={"Customer Information"}
            haswidth={true}
            value={props?.data.customerDescription}
            error={false}
            customWidth="100%"
            hasMultipleLine={true}
            onChange={(e) => {
              props?.customerDescriptionChangeValue(e?.target);
            }}
            onClearClick={()=>{
                props?.customerDescriptionChangeValue('');
            }}
            message={""}
            readOnly={false}
          />
        </Box>
      </Box>
    </Box>
  );
};

const RenderFooter = (props) => {
  const gridtheme = useSelector((state) => state.themeData.gridtheme);
  const [t] = useTranslation("common");

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box display="flex">
          <Button
            variant="outlined"
            // spacing={2}
            sx={{
              width: "50% !important",
              // flexGrow: 1,
              minWidth: "80px !important",
              maxWidth: "80px !important",
              margin: 1,
              backgroundColor: "#f7f7f7",
              borderColor: gridtheme?.colorWhite,
              color: gridtheme?.colorblack,
              boxShadow: "0 0 7px -2px white",
              //   color:SearchButtonTheme?.clear_button_text_color,
              "&:hover": {
                backgroundColor: "#f7f7f7",
                borderColor: gridtheme?.colorWhite,
                color: gridtheme?.colorblack,
                boxShadow: "0 0 7px 1px white",
                boxShadow: "0",
              },
              height: "35px",
              fontFamily: "Cairo-Bold",
            }}
            className="iconeFilterClear"
            color="secondary"
            onClick={() => {
              props?.onClose();
              props.setOpen(false);
            }}
          >
            {"Close"}
          </Button>
          <Button
            variant="contained"
            // spacing={2}
            sx={{
              // flexGrow: 1,
              margin: 1,
              width: "80px !important",
              minWidth: "80px !important",
              maxWidth: "80px !important",
              "&:hover": {
                //   backgroundColor:SearchButtonTheme?.search_button_color+'88',
              },
              height: "35px",
              fontFamily: "Cairo-Bold",
            }}
            className="iconeFilterSearch"
            onClick={() => {
              props.submit();
            }}
          >
            {"Save"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

function CreateCustomer(props) {
  const classes = useStyles();
  const [data, setData] = useState({
    customerName: "",
    customerPhone: "",
    customerDescription: "",
  });
  const [spin, setspin] = useState(false);

  const [state, setstate] = useState({
    currentCustomer: {
      name: "",
      phone: "",
      description: "",
    },

    positionOf: "",
  });
  const [phoneEerror, setPhoneError] = useState({
    err: false,
    message: "",
  });
  const handlePhoneError = (phone,isSubmit) => {
    let object = {
      err: false,
      message: "",
    };
    if (isNaN(phone)) {
      object={
        ...object,
        err:true,
        message:'Invalid phone number format\n'
      }
    }
    
    if (!isNaN(phone)&&(phone?.length>11||phone?.length<11)) {
        object={
          ...object,
          err:true,
          message:object?.message+'phone number must be 11 digit\n'
        }
    }
    if(!isNaN(phone)){
        const pattern = /07[5-9][0-9]{8}/;
        if (!pattern.test(phone)) {
          object={
            ...object,
            err:true,
            message:object?.message+'phone number format is not valid (ex:07x-x-xxxx-xxx)\n'
          }
        }
      }
    if(!phone){
        object = {
            err: false,
            message: "",
          };
    }
    setPhoneError(object)
    if(isSubmit&&!object?.err){
      return true;
    }
  };
  const CustomerNameChanged = (event) => {
    //console.log(event)

    setData({
      ...data,
      customerName: event?.value?event?.value?.replace(/'/g, ""):'',
    });
  };
  const customerDescriptionChangeValue = (event) => {
    setData({
      ...data,
      customerDescription: event?.value?event?.value?.replace(/'/g, ""):'',
    });
  };
  const CustomerPhoneChanged = (event) => {
    setData({
      ...data,
      customerPhone: event.value,
    });
  };

  const showInfo = () => {
    props.setpopupVisible(true);
  };

  const hideInfo = () => {
    props.setpopupVisible(false);
    if (props.inUpdateProcess) {
      props.setOpenEditDialog(true);
    } else {
      props.setOpenDialog(true);
    }

    setData({
      customerName: "",
      customerPhone: "",
      customerDescription: "",
    });
  };

  const createUpdateCustomer = () => {
    if (!handlePhoneError(data?.customerPhone, true)) {
      return false;
    }
    if (data.customerName.length <= 0 || data.customerPhone.length <= 0) {
      toast.error("Please, you must enter the customer name and phone");
      return;
    }
    var headers = {
      jwt: cookies.get("token"),
    };
    var method = "POST";
    var requestFunction = "add";
    if (props.editCustomer && props.editCustomer.customer_id) {
      method = "PUT";
      requestFunction = "update/" + props.editCustomer.customer_id;
    }

    setspin(true);
    axios({
      url: Host + `customers/${requestFunction}`,
      method: method,
      headers: headers,
      data: data,
    })
      .then((res) => {
        if (res.data.status === true) {
          var customerID = 0;
          if (props.editCustomer && props.editCustomer.customer_id) {
            customerID = props.editCustomer.customer_id;
            props.setcustomerID(props.editCustomer.customer_id);
          } else {
            customerID = res.data.data.customer_id.insertId;
            props.setcustomerID(res.data.data.customer_id.insertId);
          }
          setspin(false);
          props.setpopupVisible(false);
          if (props.inUpdateProcess) {
            props.setData({
              ...props.data,
              customerId: customerID,
            });
            props.setOpenEditDialog(true);
          } else {
            props.setOpenDialog(true);
          }
          setData({
            customerName: "",
            customerPhone: "",
            customerDescription: "",
          });

          toast.success("Customer info registered successfully");
        } else if (res.data.status === false) {
          toast.error(res.data.data.message.text);
          setspin(false);
        }
      })
      .catch((err) => {
        toast.error("Network Error");
        //console.log(err)
        setspin(false);
      });

    // notify({
    //     message: message,
    //     position: {
    //         my: 'center top',
    //         at: 'center top'
    //     }
    // }, 'success', 3000);
  };
  const saveButtonOptions = {
    icon: "save",
    text: "Save",
    onClick: createUpdateCustomer,
  };
  const closeButtonOptions = {
    text: "Close",
    onClick: hideInfo,
  };

  useEffect(() => {
    if (props.editCustomer && props.editCustomer.customer_id) {
      setData({
        customerName: props.editCustomer.name,
        customerPhone: props.editCustomer.phone,
        customerDescription: props.editCustomer.description,
      });
    }else{
      setData({
        customerName: '',
        customerPhone: '',
        customerDescription: '',
      });
    }
  }, [props.popupVisible, props.editCustomer]);

  const rules = { X: /[02-9]/ };
  return (
    <PopupForm
      open={props.popupVisible}
      setOpen={hideInfo}
      onHiding={hideInfo}
      dragEnabled={false}
      closeOnOutsideClick={true}
      showCloseButton={false}
      showTitle={true}
      title="Create Customer"
      container=".dx-viewport"
      width={"60%"}
      height={"60%"}
      content={
        <RenderContent
          data={data}
          setData={setData}
          CustomerPhoneChanged={CustomerPhoneChanged}
          customerDescriptionChangeValue={customerDescriptionChangeValue}
          CustomerNameChanged={CustomerNameChanged}
          open={props.addForm}
          setOpen={props.setAddForm}
          handlePhoneError={handlePhoneError}
          phoneEerror={phoneEerror}
          setPhoneError={setPhoneError}
        />
      }
      footer={
        <RenderFooter
          open={props.addForm}
          setOpen={props.setAddForm}
          submit={()=>{
            if(handlePhoneError(data?.customerPhone,true)){
               createUpdateCustomer()
            }
        }}
          onClose={hideInfo}
        />
      }
    />
  );
}

export default CreateCustomer;
